<template>
  <v-dialog :value="showDialog" max-width="315" eager>
    <v-card ref="discardChangesDialog">
      <v-card-title class="pb-0">
        <span class="h6 grey--text text--darken-4">{{
          $t('common.button.discard_changes')
        }}</span></v-card-title
      >
      <v-card-text class="pb-3">
        <span class="grey--text text--darken-4">
          {{ $t('routines.discard_changes') }}</span
        >
      </v-card-text>
      <v-card-actions class="pb-3 justify-end">
        <Button
          plain
          data-testid="findingSettingsDialog-button-cancel"
          class="me-6"
          color="grey"
          :text="$t('common.button.cancel')"
          @click="$emit('close')"
        />
        <Button
          plain
          class="me-5"
          data-testid="findingSettingsDialog-button-save"
          color="primary"
          :text="$t('routines.discard')"
          @click="$emit('discard')"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Button from '@/components/UI/Button'
export default {
  name: 'FindingUnsavedChangesDialog',

  components: {
    Button,
  },

  props: {
    showDialog: Boolean,
  },
}
</script>
